import { MutationTree } from 'vuex'
import { IShoppingCartState, IProductExtended } from '@/@types'
import CONSTANTS from '@/constants'

const { PLANS } = CONSTANTS

const mutations: MutationTree<IShoppingCartState> = {
  SHOPPING_CART_UPDATED: (state, shoppingCart: Array<IProductExtended>) => {
    state.shoppingCart = shoppingCart
  },
  COUPON_UPDATED: (state, coupon: string) => {
    state.coupon = coupon
  },
  SHOPPING_CART_REMOVED_ITEM_UPDATED: (state, product: IProductExtended) => {
    if (product.addOnChecked) {
      product.addOnChecked = false
    }
    state.shoppingCart = state.shoppingCart.filter(item => {
      // item is NOT PLANS.SKILL_DIVE_ANNUAL
      // go for regular filtering
      item.recurlyItem = false
      if (item.merchant_id !== PLANS.SKILL_DIVE_ANNUAL) {
        return item.merchant_id !== product.merchant_id
      }
      // item is PLANS.SKILL_DIVE_ANNUAL
      // check if there are *NO* Skill Dive AddOns checked to filter the plan
      if (item.merchant_id === PLANS.SKILL_DIVE_ANNUAL && item.addOnsOnCart?.length === 0) {
        item.recurlySDLACounter = item.addOnsOnCart?.length
        item.recurlySDItem = false
        return item.merchant_id !== product.merchant_id
      }
      // if there are Skill Dive AddOns checked do not filter the plan
      return true
    })
  },
  BUNDLE_PRODUCT_ERROR_UPDATED: (state, error: { type: string }) => {
    state.bundleProductHasError = error
  },
  SHOW_PROMOTION_SAVINGS_UPDATED: (state, showPromotionSavings: boolean) => {
    state.showPromotionSavings = showPromotionSavings
  },
  IS_PROMOTION_ACTIVE_UPDATED: (state, isPromotionActive: boolean) => {
    state.isPromotionActive = isPromotionActive
  },
}

export default mutations
